// @file All GraphQL queries for walls
import gql from 'graphql-tag'

export const DELETE_PADLET: any = gql`
  mutation ($wallId: ID!) {
    deleteWall(id: $wallId) {
      id
    }
  }
`

export const ARCHIVE_PADLET: any = gql`
  mutation ($wallId: ID!) {
    archiveWall(id: $wallId) {
      id
    }
  }
`

export const UNARCHIVE_PADLET: any = gql`
  mutation ($wallId: ID!) {
    unarchiveWall(id: $wallId) {
      id
    }
  }
`

// fetching links is slow, we should only do it when needed by specifying $shouldFetchLinks
export const USER_PADLETS: any = gql`
  query (
    $userId: Int!
    $wallsFilter: WallsFilter
    $folderId: Int
    $afterCursor: String
    $loadCount: Int
    $shouldFetchLinks: Boolean!
  ) {
    user(id: $userId) {
      id
      name
      walls(filter: $wallsFilter, folder_id: $folderId, after: $afterCursor, first: $loadCount) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            title
            updated_at
            archived_at
            address
            viz
            background {
              fill
              url
              dominant_color
              dominant_color_as_rgb
              width
              height
            }
            thumbnail {
              url
              dominant_color
              dominant_color_as_rgb
              width
              height
            }
            links @include(if: $shouldFetchLinks) {
              permanent
            }
            builder {
              id
              avatar
              username
              display_name
            }
          }
        }
      }
    }
  }
`

export const WALL_NOTIFICATIONS: any = gql`
  query ($userId: Int!) {
    user(id: $userId) {
      wall_notifications {
        push_notify
        wall_id
      }
    }
  }
`

export const MUTE_PUSH_NOTIFICATIONS: any = gql`
  mutation ($wallId: ID!) {
    mutePushNotifications(wall_id: $wallId) {
      push_notify
      wall_id
    }
  }
`

export const UNMUTE_PUSH_NOTIFICATIONS: any = gql`
  mutation ($wallId: ID!) {
    unmutePushNotifications(wall_id: $wallId) {
      push_notify
      wall_id
    }
  }
`
